import { ENV } from '../config/env';

export const API_BASE_URL = ENV.API_BASE_URL;

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'shop_auth_token',
  USER_DATA: 'shop_user_data',
  CASHIER_AUTH_TOKEN: 'cashier_auth_token',
  CASHIER_DATA: 'cashier_user_data',
} as const;

/** Dispatched on shop login / logout so listeners (e.g. in-app popup gate) can refetch */
export const SHOP_AUTH_TOKEN_CHANGED_EVENT = 'shop-auth-token-changed';

/** Dispatched on cashier login / logout so listeners can refetch. */
export const CASHIER_AUTH_TOKEN_CHANGED_EVENT = 'cashier-auth-token-changed';

/** Sidebar balances: shop credits + USD online (dashboard). Dispatch after flows that change either. */
export const SHOP_CREDIT_BALANCE_REFRESH_EVENT = 'shop-credit-balance-refresh';

/** Cashier devices were approved / rejected / blocked / renamed: refresh the sidebar waiting badge. */
export const CASHIER_DEVICES_CHANGED_EVENT = 'cashier-devices-changed';

export function dispatchCashierDevicesChanged(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(CASHIER_DEVICES_CHANGED_EVENT));
}

export function dispatchShopCreditBalanceRefresh(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(SHOP_CREDIT_BALANCE_REFRESH_EVENT));
}
